import { Providers } from '../contracts';
import { IApiClient } from '../utils/api-client';
import { IFxRateService } from './contracts';

export class FxRateService implements IFxRateService {
    constructor(private readonly client: IApiClient) {

    }

    async get(fromCurrency: string, toCurrency: string, date: Date, provider: Providers): Promise<number | undefined> {
        const result = await this.client.get<number | undefined>(`/fx-rates/provider/${encodeURIComponent(provider)}`, {
            params: {
                fromCcy: fromCurrency,
                toCcy: toCurrency,
                date: date.toISOString(),
            },
        });
        return result.data;
    }
}